// extracted by mini-css-extract-plugin
module.exports = {"policy":"page-policy_policy__34cTB","closeBt":"page-policy_closeBt__rPIJb","top":"page-policy_top__1Onm3","bottom":"page-policy_bottom__37Rb6"};